import {html} from "lit";
import { property } from 'lit/decorators.js';
import {LitElement, TemplateResult} from 'lit';

type Constructor<T> =
// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new (...args: any[]) => T;

export declare class SbkLabelMixinInterface {
    hintTitle: string;
    label: string;
    required: boolean;
    labelTemplate(id: string, renderLegendTag?: boolean, invalid?: boolean): TemplateResult<1>;
}

export const SbkLabelMixin = <T extends Constructor<LitElement>>(superClass: T) => {
    class SbkLabelMixin extends superClass {
        @property({ attribute: 'hint-title' })
        hintTitle = '';

        @property({ type: Boolean, attribute: 'hide-label' })
        hideLabel: boolean = false;

        @property()
        label = '';

        @property({type: Boolean})
        required = false;
        error = false;

        labelTemplate(id: string, renderLegendTag: boolean = false, invalid: boolean = false) {
            return html`
                <div class="label__wrapper${this.hideLabel ? ' sr-only' : ''}">
                    ${renderLegendTag ? this.legendInnerTemplate(id) : this.labelInnerTemplate(id)}
                    ${this.labelHintTemplate(invalid)}
                </div>
        `;
        }

        labelHintTemplate(invalid: boolean) {
            if (!this.hintTitle) {
                return '';
            }
            return html`
                <sbk-modal heading=${this.hintTitle}>
                    <sbk-round-button size="small" slot="triggerElement" class="input__label-link" icon="question" ?error=${invalid}></sbk-round-button>
                    <slot name="hintContent"></slot>
                </sbk-modal>
        `;
        }

        labelInnerTemplate(id: string) {
            return html`
                <label for=${id} class="label">
                    <span class="label__text">${this.label.trim()}${this.renderRequiredIcon()}</span>
                </label>
        `;
        }

        legendInnerTemplate(id: string) {
            return html`
                <div id=${id} class="label">
                    <span class="label__text">${this.label.trim()}${this.renderRequiredIcon()}</span>
                </div>
        `;
        }

        renderRequiredIcon() {
            if (!this.required) {
                return '';
            }
            return html`&nbsp;<i aria-hidden="true" class="label__required-icon">*</i>`;
        }
    }
    return SbkLabelMixin as Constructor<SbkLabelMixinInterface> & T;
}